//------------- LOGIN ---------

//importações
import React from "react";
import "./styles.css";

//components
import LoginComponent from "../../components/login-component/";

//assets
import logoMosaicWhite from "../../assets/logos/mosaic-white-logo.png";

//component
const Login = ({ token, setToken }) => {
    //view do component
    return (
        <div className="div-body">
            <div className="div-left-login">
                {/* chama o component do formulário de login */}
                <LoginComponent token={token} setToken={setToken}></LoginComponent>
            </div>
            <div className="div-right-logo">
                <img className="logo-mosaic" alt="logo Mosaic" src={logoMosaicWhite}></img>
            </div>
        </div>
    );
};

export default Login;
